export default {
  addOns: 'Lisäpalvelut',
  availabilityDaySelector: 'Saatavuuspäivän valitsin',
  unavailable: 'Ei saatavilla',
  person: 'henkilö',
  people: 'henkilöä',
  reserveNow: 'Varaa nyt',
  selectTime: 'Valitse aika',
  select: 'Valitse',
  reserve: 'Varaa',
  time: 'Aika',
  tier: 'Taso',
  questions: 'Kysymykset',
  addToCart: 'Lisää ostoskoriin',
  checkout: 'Kassa',
  total: 'Yhteensä',
  availability: 'Saatavuus',
  whatsIncluded: 'Mitä sisältyy',
  showMore: 'Näytä enemmän',
  showLess: 'Näytä vähemmän',
  session: 'Istunto',
  viewDetails: 'Näytä tiedot',
  findAvailability: 'Etsi saatavuutta',
  loading: 'Ladataan',
  capacity: 'Kapasiteetti',
  noAvailableSessionsOnThisDate: 'Ei saatavilla olevia istuntoja tänä päivänä',
  noGroupAvailableOnThisDateAndTime:
    'Ei saatavilla olevia {{groupTitle}} tänä päivänä ja aikana',
  noCollectionFound: 'Kokoelmaa ei löytynyt!',
  noResourceGroupFound: 'Resurssiryhmää ei löytynyt!',
  noData: 'Ei tietoja!',
  continue: 'Jatka',
  night: 'yö',
  nights: 'yötä',
  noAvailableSessionsForSelectedDates:
    'Joillekin valitsemillesi päiville ei ole saatavilla olevia istuntoja. Valitse toiset päivämäärät.',
  from: 'alkaen',
  dateRangeSelector: 'Päivämäärävälin valitsin',
  priceTierRadioGroup: 'Hinnan taso valitsin',
  startTime: 'Aloitusaika',
  duration: 'Kesto',
  lengthOfStay: 'Oleskelun kesto',
  startDate: 'Alkamispäivä',
  endDate: 'Päättymispäivä',
  selectDates: 'Valitse päivät',
  more: 'Lisää',
  selectStartTime: 'Valitse aloitusaika',
  endTime: 'Päättymisaika',
  selectEndTime: 'Valitse päättymisaika',
  morning: 'Aamupäivä',
  afternoon: 'Iltapäivä',
  save: 'Tallenna',
  selectDuration: 'Valitse kesto',
  forLength: 'ajalle {{length}}',
  moreDates: '{{count}} lisää',
  addDate: 'Lisää päivä',
  start: 'Alku',
  end: 'Loppu',
  pickupFrom: 'Nouto alkaen',
  returnBy: 'Palautus viimeistään',
  day: 'päivä',
  days: 'päivää',
  hour: 'tunti',
  hours: 'tuntia',
};
